import type { GenericParameters } from "~/core/models/GenericParameters.type";
import LxcError from "~/core/models/LxcError.class";
import fleetService from "~/modules/fleet/services/fleet.service";

export function useDeleteFleet({ organizationCode }: GenericParameters) {
  const result = ref<void>();
  const isLoading = ref(false);
  const error = ref<LxcError | null>(null);

  async function deleteFleet(uid: string): Promise<void> {
    isLoading.value = true;

    const response = await fleetService.deleteOrganizationFleet({
      organizationCode,
      uid,
    });

    if (LxcError.check(response)) {
      error.value = response;
      result.value = undefined;
    } else {
      error.value = null;
      result.value = response;
    }

    isLoading.value = false;
  }

  return {
    deleteFleet,
    result,
    error,
    isLoading,
  };
}
